import { IOrder } from "../modals/Orders.modal";
import { IResponse } from "../modals/response.modal";
import { ITrade } from "../modals/Trade.modal";
import ApiService from "./api.service";
import axiosAuth from "./axios-interceptor";


class KCService {

    getLoginUrl() {
        return axiosAuth.get(`${ApiService.KC}/login-url`);
    }

    getCallbackToken(formData: any) {
        return axiosAuth.post(`${ApiService.KC}/callback`, formData);
    }

    getAllOrders() {
        return axiosAuth.get<IResponse<IOrder[]>>(`${ApiService.KC}/getAllOrders`);
    }

    getAllTrades() {
        return axiosAuth.get<IResponse<ITrade[]>>(`${ApiService.KC}/getAllTrades`);
    }

}

export default new KCService();
